import React, { useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

import SearchContentProf from './SearchContentProf';
import Logo from 'Components/Icons/Logo';
import QCRLogoMark from 'Components/Icons/QCRLogoMark';
import MembershipButton from './MembershipButton';
import MiniAvatar from 'Components/Icons/MiniAvatar';
import NotificationIcon from 'Components/Icons/NotificationIcon';
import { Crown } from 'lucide-react';
import { LuListFilter } from 'react-icons/lu';
import { Context } from 'Context/Context';

function AttorneyHeaderMobile({
    caseList = false,
    noSearch,
    setUpdateComp,
    unReadNotifications,
    onBellClick
}) {

    const navigate = useNavigate();
    const [openMenu, setOpenMenu] = useState(false);
    const {userDetails} = useContext(Context);
  return (
    <>
    {caseList ?
     // Case List design (mobile): navy bar — logo + name, crown, bell, avatar.
     // Section switching and case-ID search live in the white bar under it.
     <div className="col-span-6 sticky top-0 flex items-center justify-between w-full z-30 font-plexsans" style={{background:'#14213d', padding:'10px 16px 12px'}}>
        <Link className="flex items-center cursor-pointer" style={{gap:'7px'}} to="/attorney/casesFeed/availableCases">
            <QCRLogoMark size={17} color="#c9a26a"/>
            <span style={{font:"600 12px/1 'IBM Plex Sans',sans-serif", letterSpacing:'.05em', textTransform:'uppercase', color:'#f7f4ed'}}>Quick Case Review</span>
        </Link>
        <div className="flex items-center" style={{gap:'14px'}}>
            <Link to="/attorney/subscription" title={userDetails?.isActiveSubscription ? 'Premium membership' : 'Upgrade to Premium'} className="flex">
                <Crown size={16} fill="#c9a26a" strokeWidth={0}/>
            </Link>
            <div className="cursor-pointer" onClick={onBellClick}>
                <NotificationIcon size={18} count={unReadNotifications} color="text-[rgba(247,244,237,0.75)]"/>
            </div>
            <MiniAvatar size={28}/>
        </div>
     </div>
    :
    <>
     {/* Other attorney pages (mobile): same navy bar as the case list - menu, logo + name, bell, avatar */}
     <div className="col-span-6 sticky top-0 flex items-center justify-between gap-3 w-full z-30 font-plexsans bg-navy pt-2.5 pb-3 px-4 min-h-[52px]">
        <div className="flex items-center gap-3 min-w-0">
            <Link className="flex items-center gap-[7px] cursor-pointer min-w-0" to="/attorney/casesFeed/availableCases">
                <QCRLogoMark size={17} color="#c9a26a"/>
                <span className="font-plexsans font-semibold text-[12px] leading-none tracking-[.05em] uppercase text-ivory whitespace-nowrap">Quick Case Review</span>
            </Link>
        </div>
        <div className="flex items-center gap-3.5 flex-none">
            <div className="cursor-pointer" onClick={onBellClick}>
                <NotificationIcon size={18} count={unReadNotifications} color="text-[rgba(247,244,237,0.75)]"/>
            </div>
            <MiniAvatar size={28}/>
        </div>
    </div>
    <div className='col-span-6 w-full flex justify-center items-center '>
            {!noSearch ? 
                <SearchContentProf size="l" 
                setUpdateComp={setUpdateComp}
                />
                : null}
        </div>
    </>
    }
        </>
  )
}

export default AttorneyHeaderMobile
